import axios from 'axios'
import { getToken } from 'lib/localStorage'

const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_API_URL ?? 'http://localhost:4000'
})

axiosInstance.interceptors.request.use(
  (config) => {
    // Get the token from your storage or state
    const token = getToken()
    // Add the token to the headers
    if (config.url !== '/auth/login') {
      config.headers.Authorization = `Bearer ${token.value}`
    }

    return config
  },
  (error) => {
    return Promise.reject(error)
  }
)

axiosInstance.interceptors.response.use(
  (response) => {
    // Process the successful response here
    return response.data
  },
  (error) => {
    // Process the error response here
    if (error.response.status === 401) {
      // window.location.href = '/login'
    }
    if (error.response.status === 404) {
      // console.log(error.response.data)
    }
    return Promise.reject(error)
  }
)

export default axiosInstance
